module.exports = __webpack_public_path__ + "static/media/circleFrame1.29577acf.svg";